import React from 'react';
import { CameraIcon } from 'lucide-react';
import { CreativeDirectoryPage, CreativeArtist } from '../../components/creative/CreativeDirectoryPage';
const artists: CreativeArtist[] = [{
  id: '1',
  name: 'Avery Johnson',
  title: 'Author Photographer',
  specialties: ['Portraits', 'Book Events', 'Marketing Photos'],
  rating: 4.9,
  reviewCount: 115,
  imageUrl: 'https://images.unsplash.com/photo-1504257432389-52343af06ae3?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  available: true,
  priceRange: '$200-800'
}, {
  id: '2',
  name: 'Skyler Thomas',
  title: 'Book Cover Photographer',
  specialties: ['Product Photography', 'Landscapes', 'Conceptual'],
  rating: 4.6,
  reviewCount: 82,
  imageUrl: 'https://images.unsplash.com/photo-1542909168-82c3e7fdca5c?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  available: true,
  priceRange: '$300-1000'
}];
const Photographers = () => <CreativeDirectoryPage title="Professional Photographers" subtitle="Connect with experienced photographers for author portraits, book covers, and event photography" icon={<CameraIcon className="h-8 w-8" data-id="element-8627" data-mp="j1di068d3agg" />} profileBasePath="/creative/photographers" artists={artists} data-id="element-8626" data-mp="1hi47wql81wud" />;
export default Photographers;